import React, { useState, useEffect } from "react";
import "./css/related-products.css";
import Item from "./Item";
import axios from "axios";
import ItemSkeleton from "../skeletons/Item";

const RelatedProducts = ({ product, loading }) => {
    const productId = product?._id;

    const [relatedProducts, setRelatedProducts] = useState([]);
    const [loadingState, setLoadingState] = useState(false);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    // Fetch Related Products after productId is ready
    useEffect(() => {
        if (!productId) return;
        setLoadingState(true);

        axios
            .get(`${backendUrl}/related-products/${productId}`)
            .then((res) => {
                setRelatedProducts(res.data.products || []);
            })
            .catch((err) => console.error("Error fetching related products:", err))
            .finally(() => setLoadingState(false));
    }, [productId, backendUrl]);

    const showSkeletons = loading || loadingState;

    return (
        <div className="related-products">
            <h1>Related Products</h1>
            <hr />
            <div className="related-product-items">
                {showSkeletons ? (
                    <ItemSkeleton />
                ) : relatedProducts.length > 0 ? (
                    relatedProducts.map((item, i) => (
                        <Item
                            key={i}
                            id={item._id}
                            image={item.primaryImage}
                            name={item.name}
                            new_price={item.new_price}
                            old_price={item.old_price}
                        />
                    ))
                ) : (
                    <p className="no-products">No related products found.</p>
                )}
            </div>
        </div>
    );
};

export default RelatedProducts;